export default __webpack_public_path__ + "static/media/ROUND.8601ae1f.jpg";